export const skillGroups = [
  {
    category: 'Développement Frontend',
    icon: 'code',
    iconColor: 'text-rihen-teal',
    description: 'Interfaces React et Next.js rapides, modernes et accessibles.',
    items: [
      { name: 'React.js', level: 90 },
      { name: 'Next.js', level: 85 },
      { name: 'Tailwind CSS', level: 95 },
      { name: 'HTML5/CSS3', level: 90 },
      { name: 'JavaScript', level: 90 },
      { name: 'TypeScript', level: 85 },
    ],
  },
  {
    category: 'Développement Backend',
    icon: 'server',
    iconColor: 'text-rihen-gold',
    description: 'APIs Node.js, NestJS et Laravel robustes, sécurisées et scalables.',
    items: [
      { name: 'Node.js', level: 85 },
      { name: 'Express.js', level: 85 },
      { name: 'NestJS', level: 85 },
      { name: 'PHP', level: 80 },
      { name: 'Laravel', level: 80 },
      { name: 'REST API', level: 90 },
      { name: 'GraphQL', level: 75 },
    ],
  },
  {
    category: 'CMS & E-commerce',
    icon: 'layoutGrid',
    iconColor: 'text-rihen-teal',
    description: 'Sites WordPress, Drupal et boutiques PrestaShop sur mesure.',
    items: [
      { name: 'WordPress', level: 90 },
      { name: 'Drupal', level: 85 },
      { name: 'PrestaShop', level: 80 },
    ],
  },
  {
    category: 'Salesforce',
    icon: 'cloud',
    iconColor: 'text-rihen-teal',
    description: 'Développement Salesforce certifié : Apex, LWC et admin.',
    items: [
      { name: 'Salesforce Associate', level: 90 },
      { name: 'Développement Salesforce', level: 85 },
      { name: 'Apex', level: 85 },
      { name: 'Lightning Web Components', level: 80 },
      { name: 'Salesforce Administration', level: 85 },
    ],
  },
  {
    category: 'Base de données',
    icon: 'database',
    iconColor: 'text-rihen-teal',
    description: 'Bases SQL et NoSQL optimisées pour la performance.',
    items: [
      { name: 'MySQL', level: 85 },
      { name: 'MongoDB', level: 80 },
      { name: 'PostgreSQL', level: 75 },
    ],
  },
  {
    category: 'Design & UI/UX',
    icon: 'palette',
    iconColor: 'text-rihen-gold',
    description: 'UI/UX soignée de la maquette au responsive avec Figma.',
    items: [
      { name: 'Figma', level: 85 },
      { name: 'UI Design', level: 85 },
      { name: 'UX Design', level: 80 },
      { name: 'Responsive Design', level: 90 },
      { name: 'Accessibilité', level: 80 },
    ],
  },
  {
    category: 'Motion design',
    icon: 'sparkles',
    iconColor: 'text-rihen-gold',
    description: 'Animations GSAP et Framer Motion au service du récit et de l’interface.',
    items: [
      { name: 'GSAP', level: 85 },
      { name: 'Framer Motion', level: 85 },
      { name: 'Micro-interactions', level: 80 },
    ],
  },
  {
    category: 'Intelligence artificielle',
    icon: 'brain',
    iconColor: 'text-rihen-teal',
    description: 'Intégration OpenAI pour des applications de génération en production.',
    items: [
      { name: 'OpenAI API', level: 80 },
      { name: 'Génération de contenu', level: 80 },
      { name: 'Génération d’images', level: 75 },
    ],
  },
  {
    category: 'Paiements en ligne',
    icon: 'creditCard',
    iconColor: 'text-rihen-gold',
    description: 'Encaissement Stripe et Mobile Money, du checkout aux commissions.',
    items: [
      { name: 'Stripe', level: 80 },
      { name: 'Mobile Money', level: 80 },
      { name: 'Webhooks de paiement', level: 75 },
    ],
  },
  {
    category: 'Outils & Technologies',
    icon: 'gitBranch',
    iconColor: 'text-rihen-teal',
    description: 'Git, Jira et Postman au service d\'un delivery agile.',
    items: [
      { name: 'Git & GitHub', level: 90 },
      { name: 'Bitbucket', level: 85 },
      { name: 'Jira', level: 80 },
      { name: 'Postman', level: 85 },
      { name: 'Suite MS Office', level: 90 },
      { name: 'Vibe Coding', level: 85 },
    ],
  },
];
